import { Stack } from "@mui/material";
import List from "@mui/material/List";

import { type Insight } from "../../../Insights/types";
import { AmountInCustomerCurrency } from "../AmountInCustomerCurrency";
import { CardPager } from "../CardPager";
import HomePageCard from "../HomePageCard";
import { InsightRow } from "../Rows/InsightRow";
import { LoadingRow } from "../Rows/LoadingRow";
import { ITEMS_PER_PAGE, usePagination } from "./hooks";

export const ActiveInsightsList = ({
  insights,
  costAtRisk,
  loading,
}: {
  insights: Insight[];
  costAtRisk: number;
  loading: boolean;
}) => {
  const { currentPage, handlePageChange, startItem, endItem, totalItems, currentPageItems } = usePagination(insights);

  return (
    <HomePageCard
      title="Actionable Insights by cost impact"
      subheader={
        <>
          Ignoring active recommendations could result in{" "}
          <b>
            <AmountInCustomerCurrency amount={costAtRisk} />
          </b>{" "}
          of costs per year
        </>
      }
      loading={loading}
      sxProps={{ height: "100%" }}
    >
      <Stack sx={{ flex: 1, justifyContent: "space-between" }}>
        <List dense sx={{ pb: 0, pt: 0, "& .MuiListItem-root:last-of-type": { borderBottom: "none" } }}>
          {loading &&
            Array.from({ length: 7 }).map((_, index) => (
              <LoadingRow key={`loading-row-${index}`} hideDivider={index === 6} />
            ))}
          {currentPageItems.map((insight, index) => (
            <InsightRow
              key={`${insight.title}-${index}`}
              insight={insight}
              hideDivider={index === currentPageItems.length - 1 && currentPageItems.length === ITEMS_PER_PAGE}
            />
          ))}
        </List>
        <CardPager
          startItem={startItem}
          endItem={endItem}
          totalItems={totalItems}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </Stack>
    </HomePageCard>
  );
};
